/* eslint-disable max-len */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import GenericListPair from 'modules/common/components/GenericListPair';
import { ModalContext } from 'App';
import useDebounce from 'modules/common/components/UseDebounce';
import ToggleFetcherTimer from 'modules/common/components/ToggleFetcherTimer';
import * as actions from '../action';
import * as c from '../constant';
import TaxClearanceContent from './TaxClearanceContent';
import ViewTransmittalModal from '../components/ViewTransmittalModal';
import ReprintTransmittalModal from '../components/ReprintTransmittalModal';

const form = {
  keyword: '',
  transaction_status: '',
  start_date: '',
  end_date: '',
  module_type: 'RPTAXC',
};

function TaxClearanceContainer({
  getTransactionList,
  transactionList,
  transactionListPager,
  match,
  isLoading,
  history,
  showTransaction,
  permissions,
  generateTransmittal,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(form);
  const [filter, setFilter] = useState(form);
  // const token = get('token') || '';
  // const authProfile = getJson('profile') || {};
  const [countChar, setCountChar] = useState(0);

  const UpdateData = () => {
    getTransactionList();
    return () => {
      setModal({ isOpen: false });
    };
  };

  const param = {
    module_type: 'RPTAXC',
    q: formData.keyword,
    sort_by: 'asc',
    transaction_status: filter.transaction_status,
  };

  const handleOnChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setCountChar(e.target.value.length);
  };

  useEffect(() => {
    UpdateData();
  }, []);

  const handleOnChangeSelect = key => e => {
    setFilter({
      ...filter,
      [key]: e.value,
      transaction_status: e.value,
    });
    getTransactionList({ ...filter, transaction_status: e.value });
  };

  const debouncedSearchTerm = useDebounce(formData, 500);

  useEffect(() => {
    if (debouncedSearchTerm && countChar >= 3) {
      getTransactionList({ module_type: 'RPTAXC', q: formData.keyword });
    } else {
      getTransactionList({ module_type: 'RPTAXC' });
    }
  }, [debouncedSearchTerm]);

  const onCallbackTimer = () => {
    getTransactionList({
      module_type: 'RPTAXC',
      q: formData.keyword,
      transaction_status: filter.transaction_status,
    });
  };

  const onGenerateTransmittal = e => {
    e.preventDefault();

    setFormData({
      ...formData,
      isLoading: true,
      generate: true,
      url: '',
    });

    generateTransmittal({}, res => {
      setModal({
        isOpen: true,
        content: (
          <ViewTransmittalModal
            transmittalNumber={_.get(res, 'res.data.attributes.transmittal_no')}
          />
        ),
        title: 'Generate Transmittal',
        modalSize: 'modal-xl',
      });
    });

    setTimeout(() => {
      const id = history.location.pathname.replace(
        '/real-property-tax/tax-clearance/',
        ''
      );
      showTransaction(id);
    }, 2000);
  };

  // const onGenerateTransmittal = e => {
  //   e.preventDefault();
  //   setModal({
  //     isOpen: true,
  //     content: <ViewTransmittalModal />,
  //     title: `RPTAX Clearance Transmittal`,
  //     modalSize: 'modal-xl',
  //   });
  // };

  const reprintTransmittal = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ReprintTransmittalModal type="NEW" />,
      title: null,
      modalSize: 'modal-sm',
    });
  };

  return (
    <div className="card-content-listing">
      <div className="transmital">
        <ToggleFetcherTimer callback={onCallbackTimer} />
        <div className="d-flex justify-content-end mr-3 my-2">
          {Acl(permissions, ['RPTAX CLEARANCE PRINT TRANSMITTAL']) && (
            <button
              type="submit"
              className="btn btn-primary cms-bg-color-primary cms-outline-primary  gen-btn font-weight-bold mr-2"
              onClick={onGenerateTransmittal}
            >
              PRINT TRANSMITTAL &nbsp;
              <i className="fas fa-print" />
            </button>
          )}
          {Acl(permissions, ['RPTAX CLEARANCE REPRINT TRANSMITTAL']) && (
            <button
              type="submit"
              className="btn btn-primary cms-bg-color-primary cms-outline-primary  gen-btn font-weight-bold"
              onClick={reprintTransmittal}
            >
              REPRINT TRANSMITTAL &nbsp;
              <i className="fas fa-print" />
            </button>
          )}
        </div>
      </div>

      <Route
        path={`${match.path}/:id?`}
        render={({ match: { params } }) => (
          <GenericListPair
            getData={getTransactionList}
            setParams={param}
            setKeyword={handleOnChange}
            setStatusFilter={handleOnChangeSelect(
              _.get(formData, 'transaction_status')
            )}
            status={_.get(filter, 'transaction_status') || ''}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search Transaction..."
            pathName={`${match.path}/:id?`}
            listName="Transaction"
            label="Transaction List"
            renderItem={item => (
              <div className="px-3 py-3">
                <div className="transaction-list-company">
                  {`${_.get(item, 'attributes.name')}`}
                </div>
                <h4 className="mt-1 mb-0 transaction-list-name">
                  {_.get(item, 'included.module.attributes.tdn')}
                </h4>
              </div>
            )}
            isLoading={isLoading}
            statusFilter
            selected={params.id}
            data={transactionList}
            dataPager={transactionListPager}
            handleSelectRow={data => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:id?`}
                    render={() => (
                      <TaxClearanceContent UpdateData={UpdateData} />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:id?`}
                  render={() =>
                    !params.business_Id && transactionList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(transactionList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

TaxClearanceContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  transactionList: PropTypes.instanceOf(Array).isRequired,
  transactionListPager: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
  generateTransmittal: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionList: _.get(api, `${c.GET_TRANSACTION}.list`) || [],
  transactionListPager: _.get(api, `${c.GET_TRANSACTION}.pager`) || {},
  isLoading: api.loading.indexOf(c.GET_TRANSACTION) > -1,
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TaxClearanceContainer);
